import cssMobile from '../../../css/editorMobile.module.css'
import BringForwardButton from '../../toolbox/buttons/BringForwardButton'
import SendBackButton from '../../toolbox/buttons/SendBackButton'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

export default function ReorderControls({open, onBackClick}: ControlsProps) {
  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      <div className={cssMobile.controlItemsRow}>
        <SendBackButton />
        <BringForwardButton />
      </div>
    </ControlsBase>
  )
}
